import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import HomeModule from '@/modules/HomeModule';
import OfferModule from '@/modules/OfferModule';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomeModule',
      component: HomeModule,
      props: true,
    },
    {
      path: '/users/:userId/schedules/:scheduleId/offers/:offerId',
      name: 'OfferModule',
      component: OfferModule,
      props: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log('router.beforeEach to', to.name);
  console.log('router.beforeEach session', store.getters.session);
  // const session = store.getters.session;
  // if session is empty reload
  // if (to.name == 'HomeModule' && !session) {
  //   return next({ name: 'OfferModule' });
  // }

  next();
});

export default router;
